import { render, staticRenderFns } from "./OrginationPositionView.vue?vue&type=template&id=a55d650a&scoped=true"
import script from "./OrginationPositionView.vue?vue&type=script&lang=js"
export * from "./OrginationPositionView.vue?vue&type=script&lang=js"
import style0 from "./OrginationPositionView.vue?vue&type=style&index=0&id=a55d650a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55d650a",
  null
  
)

export default component.exports